import { ProfileForm } from 'components/forms/profile-form/profile-form';
import { useCallback, useEffect, useState } from 'react';
import {
  loadUserProfileThunk,
  updateProfileThunk,
} from 'store/authentication/authentication.thunks';

import * as utils from '../../../shared/utils';
import { useAppDispatch, useAppSelector } from '../../../store';
import { vocabulary } from '../../../vocabulary/german';
import { Container } from '../../template/container/container';
import { PageHeader } from '../../template/page-header/page-header';

export const ProfilePage = () => {
  const dispatch = useAppDispatch();

  const authentication = useAppSelector((state) => state.authentication);
  const [equalPasswordError, setEqualPasswordError] = useState(false);
  const [strongPasswordError, setStrongPasswordError] = useState(false);

  useEffect(() => {
    dispatch(loadUserProfileThunk());
  }, [dispatch]);

  const handleSubmit = useCallback(
    ({ email, password, repeatPassword }) => {
      const isEmptyPassword = password === '';

      setEqualPasswordError(false);
      setStrongPasswordError(false);

      if (!isEmptyPassword && password !== repeatPassword) {
        setEqualPasswordError(true);
      } else if (!isEmptyPassword && !utils.validateStrongPassword(password)) {
        setStrongPasswordError(true);
      } else {
        dispatch(updateProfileThunk({ email, password }));
      }
    },
    [dispatch],
  );

  return (
    <div className="page-content">
      <PageHeader
        title={vocabulary.labels.profile}
        btnText=""
        downloadReport={null}
      />
      <Container>
        <ProfileForm
          authentication={authentication}
          equalPasswordError={equalPasswordError}
          strongPasswordError={strongPasswordError}
          onSubmit={handleSubmit}
        />
      </Container>
    </div>
  );
};
